import {mapPartialStoppage} from '@domain/shifthandover'
import {ShiftEvent, Stoppage, StoppageDto} from '@hconnect/common/types'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {SetURLSearchParams, useSearchParams} from 'react-router'

import {ViewMode} from '../types'

function urlParamsToViewMode(params: URLSearchParams, timezone: string): ViewMode {
  const eventId = params.has('eventId') ? params.get('eventId') : undefined
  const mode = params.has('mode') ? params.get('mode') : undefined

  let initialEventCreateData: Partial<Stoppage> | undefined
  try {
    const initialEventCreateDataParam = params.has('initialData')
      ? decodeURIComponent(params.get('initialData') as string)
      : undefined
    const initialData: Partial<StoppageDto> =
      initialEventCreateDataParam && JSON.parse(initialEventCreateDataParam)
    // TODO: check if this is used only for stoppages
    initialEventCreateData = initialData && mapPartialStoppage(initialData, timezone)
  } catch (e) {
    console.log('Error parsing initial stoppage data', e)
  }

  switch (mode) {
    case undefined:
      if (eventId) return {mode: 'detailsMode', itemId: eventId} as ViewMode
      else return {mode: 'tableOnlyMode'} as ViewMode

    case 'editMode':
    case 'detailsMode':
      if (!eventId) throw new Error('Event Id must be given with mode')
      return {mode, itemId: eventId}
    case 'createMode':
      return {mode, initialData: initialEventCreateData}
    default:
      throw new Error('Unknown mode given in URL')
  }
}

export function viewModeToUrlParams(viewMode: ViewMode) {
  const params = new URLSearchParams()

  switch (viewMode.mode) {
    case 'tableOnlyMode':
      return params
    case 'editMode':
    case 'detailsMode':
      params.append('mode', viewMode.mode)
      params.append('eventId', viewMode.itemId.toString())
      return params
    case 'createMode':
      params.append('mode', 'createMode')
      // add initial data to params
      if (viewMode.initialData)
        params.append('initialData', encodeURIComponent(JSON.stringify(viewMode.initialData)))
      return params
    default:
      throw new Error('Unknown mode')
  }
}

export const useQueryParameterForViewMode = (plantId: string): ViewMode => {
  const [params]: [URLSearchParams, SetURLSearchParams] = useSearchParams()
  const timezone = useUpmPlantTimezone(plantId)
  return urlParamsToViewMode(params, timezone)
}

export const modeAfterClose = (original?: ShiftEvent, editVersion?: ShiftEvent): ViewMode => {
  if (original) {
    // 'editMode'
    return {mode: 'detailsMode', itemId: original.id}
  } else if (!original && editVersion) {
    // 'createMode'
    return {mode: 'tableOnlyMode'}
  } else {
    // 'detailsMode'
    return {mode: 'tableOnlyMode'}
  }
}
